import { createFileRoute, redirect } from '@tanstack/react-router'
import InviteCodesPage from '@/views/invite-codes-page'
import { hasOrgPermission } from '@/user/user'
import { users } from '@/api/api'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/invite-codes/',
)({
  component: InviteCodesPage,
  beforeLoad: async ({ context, params }) => {
    // Get current user data
    const user = await context.queryClient.ensureQueryData(users.me())

    // Check if user has permission to manage organization (admin only)
    if (
      !hasOrgPermission(
        user,
        params.organizationId,
        'sensorkit_meta.change_organization',
      )
    ) {
      throw redirect({
        to: '/organization/$organizationId',
        params: { organizationId: params.organizationId },
      })
    }
  },
})
